import type { FC } from 'react';
import { Draggable } from 'react-beautiful-dnd';

import { DragDropContainer } from 'components/drap-drop/DrapDropContainer';
import { SubTitle } from 'components/text/SubTitle';
import { Typography } from 'enable-ui';

import { Body, TableHeader } from '../styles/dashboard';

import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { ReactComponent as DrapDropIcon } from 'assets/icons/drap-drop.svg';
import { ReactComponent as DuplicateIcon } from 'assets/icons/duplicate.svg';

import type { Lessons } from '../core/type';

import { COLOR, COLOR_CONFIG } from 'constants/color';

import { CustomHeader } from './CustomHeader';

const LessonTableHeader = () => {
  return (
    <TableHeader style={{ minHeight: 48, padding: '8px 0' }}>
      <div style={{ minWidth: '24px' }}></div>
      <div style={{ minWidth: '42px' }}>
        <Typography
          style={{ textAlign: 'center', color: COLOR_CONFIG['neutral-text'] }}
          weight={600}
        >
          #
        </Typography>
      </div>
      <CustomHeader
        title="Lesson"
        styleHeader={{ width: '100%', display: 'flex', flexGrow: 1, padding: '0 8px' }}
        id="name"
      />
      <CustomHeader title="" styleHeader={{ minWidth: '32px', whiteSpace: 'normal' }} id="id" />
    </TableHeader>
  );
};

export const LessonTable: FC<{
  lessons: Lessons[];
  onDelete: (index: number) => void;
  onDragEnd: (result: any) => void;
}> = ({ lessons, onDelete, onDragEnd }) => {
  const renderBodyTable = (item: Lessons, index: number) => {
    return (
      <Body
        $color={`${(index + 1) % 2 === 0 ? '#f9f9f9' : '#fff'}`}
        style={{
          // borderBottom: `1px solid ${neutral['neutral-3']}`,
          padding: '12px 0',
        }}
        key={index}
      >
        <div className="flex items-center">
          <DrapDropIcon />
          <div style={{ width: '42px', padding: '0px 8px' }}>
            <Typography
              size={16}
              height={22}
              className="text-center"
              color={COLOR_CONFIG['neutral-text']}
            >
              {index + 1}.
            </Typography>
          </div>

          <article style={{ padding: '0px 8px' }}>
            <Typography
              size={16}
              height={22}
              weight={600}
              variant="h5"
              color={COLOR.surfaceNeutralBold['neutral-11']}
            >
              {item.name}
            </Typography>
            <SubTitle leftTitle={item.type.name} rightTitle={`${item.totalExercises} exercises`} />
          </article>
        </div>

        <div style={{ display: 'flex', gap: 6, alignItems: 'center', padding: '6px 0 0 0 ' }}>
          {/* <DuplicateIcon style={{ cursor: 'pointer', width: 32 }} /> */}
          <CloseIcon style={{ cursor: 'pointer', width: 32 }} onClick={() => onDelete(index)} />
        </div>
      </Body>
    );
  };

  return (
    <div style={{ overflow: 'auto' }}>
      <div style={{ minWidth: 'max-content' }}>
        <LessonTableHeader />
        {lessons.length ? (
          <div style={{ paddingBottom: 46, minWidth: '100%' }}>
            <DragDropContainer onDragEnd={onDragEnd}>
              {lessons.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(providedItem) => (
                    <div
                      ref={providedItem.innerRef}
                      {...providedItem.draggableProps}
                      {...providedItem.dragHandleProps}
                    >
                      {renderBodyTable(item, index)}
                    </div>
                  )}
                </Draggable>
              ))}
            </DragDropContainer>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
